// extracted by mini-css-extract-plugin
export default {"createTeamModal":"CreateTeamModal_createTeamModal__BXPl+","header":"CreateTeamModal_header__2rg+o","divider":"CreateTeamModal_divider__f4zAL"};